import { useEffect } from 'react';

import { Layers } from './index';

/**
 * Hook for tracking screen views with Expo Router.
 *
 * @param usePathname - The `usePathname` hook from `expo-router`.
 * @param useGlobalSearchParams - The `useGlobalSearchParams` hook from `expo-router`.
 */
export function useLayersExpoRouterTracking(
  usePathname: () => string,
  useGlobalSearchParams: () => Record<string, string | string[]>
) {
  const pathname = usePathname();
  const params = useGlobalSearchParams();

  // Serialize params to avoid infinite re-renders due to object reference changes
  const paramsString = JSON.stringify(params);

  useEffect(() => {
    if (pathname) {
      // Convert params to a flat object for properties
      const properties: Record<string, any> = {};

      // Handle potential array values in params
      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          properties[key] = value.join(',');
        } else {
          properties[key] = value;
        }
      });

      Layers.screen(pathname, properties).catch((err) => {
        console.warn('[Layers] Failed to track screen view:', err);
      });
    }
  }, [pathname, paramsString]);
}

/**
 * Component for tracking screen views with Expo Router.
 * Render this in your root `_layout.tsx`.
 */
export function LayersExpoRouter({
  usePathname,
  useGlobalSearchParams
}: {
  usePathname: () => string;
  useGlobalSearchParams: () => Record<string, string | string[]>;
}) {
  useLayersExpoRouterTracking(usePathname, useGlobalSearchParams);
  return null;
}
